import React from 'react'
import PropTypes from 'prop-types'
import './search-filters.css'

const ContactsFilter = ({
  onChange,
  value,
}) => (
  <select
    className="contactsFilter"
    value={value}
    onChange={e => onChange(e)}
  >
    <option key="all" value="all">All Contacts</option>
    <option key="leads" value="leads">Leads</option>
    <option key="conversions" value="conversions">Conversions</option>
  </select>
)

ContactsFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}

export default ContactsFilter



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/ContactsFilter.js